import React from "react";
import "./custom2.css";

//Preventing right-click > save Image (I know they can just do printScreen, but that is in low res)
//document.addEventListener('contextmenu', event => event.preventDefault());

function Custom5() {
    return(
        <a className="customContainer" href="/custom6">
            <div className="liliesBorder">
                <img src="./images/liliesBorder.jpg" className="liliesBorderImage" alt="Decoration" />
            </div>
            <div className="slideContainer" id="slide2">
                <div className="stepContainer">
                    <span className="stepBox"></span>
                    <span className="stepText">
                        The Line Drawing
                    </span>
                    <span className="arrowFloat">
                        <img className="rightArrow" src="./images/misc/arrowright2.gif" alt="cue to click for next slide."></img>
                    </span>
                </div>
            </div>
            <div className="instructions">
                <div className="instructionText">
                    You will be sent a large scale drawing that shows every piece that would need to be cut for that level of detail. You can examine it and make suggestions for improvements or changes.
                </div>
                <img className="instructionImage" src="./images/commission/lineDrawing.jpg" alt="Line drawing shown for an old english inn."></img>
            </div>
        </a>
    );
};


export default Custom5